import BackbonePubSubService from 'client/services/backbone-pub-sub-service';
const pubsub = require('pubsub');

const setupBackbonePubsubService = async () => {
  BackbonePubSubService.initialize(pubsub);
};

export default setupBackbonePubsubService;
